import { SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Divider } from 'antd';
import React, { ReactElement } from 'react';

interface IMultiSelectCheckbox {
  options: any[];
  value: string[];
  onChange: any;
  onSearch: any;
}
const MultiSelectCheckbox = ({
  options = [],
  value = [],
  onChange = (): any => { },
  onSearch = (): any => { } }: IMultiSelectCheckbox): ReactElement => {
  return (
    <React.Fragment>
      <div>
        {options.map(({ name, shortName, uniqueIdentifier }: any): ReactElement => (
          <div key={uniqueIdentifier} className="w-100 mb-sm">
            <Checkbox
              checked={value.includes(uniqueIdentifier)}
              onChange={(event: any): any => onChange(event.target.checked, uniqueIdentifier)}
            >
              {shortName || name}
            </Checkbox>
          </div>
        ))}
      </div>
      <Divider className="mt-0 mb-0" />
      <div className="text-right mt-sm"><Button icon={<SearchOutlined />} onClick={onSearch} type="primary">Apply</Button></div>
    </React.Fragment>
  );
};

export default MultiSelectCheckbox;
